/* eslint-disable react/no-unescaped-entities */
import { MongoCredentials } from '@/mongo/mongo'
import react from 'react'

interface MongoConnectedAppProps {
  connectionString?: string
  writtenAtField?: string
  collections?: MongoCredentials['collections']
  sessionId?: string
}

const MongoConnectedApp = (props: MongoConnectedAppProps) => {
  const [connectionString, setConnectionString] = react.useState(props.connectionString)
  const [writtenAtField, setWrittenAtField] = react.useState(props.writtenAtField)
  const [collections, setCollections] = react.useState(props.collections)
  const [saved, setSaved] = react.useState(false)
  const [error, setError] = react.useState('')

  const buttonEnabled = `
    border-2 border-slate-400 border-solid hover:border-blue-700
    bg-blue-100 hover:bg-blue-700 
    text-slate-400 hover:text-slate-50
    font-bold text-sm 
    -mt-2 px-2 rounded`

  const buttonDisabled = `
    border-2 hover:border-slate-400 border-solid border-blue-700
    hover:bg-blue-100 bg-blue-700 
    hover:text-slate-400 text-slate-50
    font-bold text-sm 
    -mt-2 px-2 rounded`

	async function handleSaveConfigData(data: {[key: string]: any}) {
    // Save data
		const resp = await fetch(`/api/mongo/data`, {
			method: 'post',
			headers: {
				Session: props.sessionId!,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data)
		})

    // Handle errors
    if (!resp.ok) {
      console.error('Failed to save mongo config data', resp)
      setError('Error saving data')
      return
    }

    // Parse response
    const json = await resp.json()
    console.info('saved config data', json)

    // Provide user feedback
    setSaved(true)

    setTimeout(() => {
      setSaved(false)
    }, 4000)

    setError('')

		return json.success
	}

  function handleCollectionChange(value: string, collection: string) {
    setCollections({
      ...collections,
      [collection]: {
        lastUpdatedField: value
      }
    })
  }

  // function handleSyncChange(value: boolean, collection: string) {
  //   debugger
  //   setCollections({
  //     ...collections,
  //     [collection]: {
  //       lastUpdatedField: collections![collection]!.lastUpdatedField,
  //       syncing: !value
  //     }
  //   })
  // }

  function handleSyncChange(collection: string) {
    const current = collections![collection]?.syncing

    setCollections({
      ...collections,
      [collection]: {
        lastUpdatedField: collections![collection]!.lastUpdatedField,
        syncing: !current
      }
    })
  }

  react.useEffect(() => {
    console.log('updating state', props)
    setConnectionString(props.connectionString)
    setWrittenAtField(props.writtenAtField)
    setCollections(props.collections)
  }, [props.writtenAtField, props.connectionString, props.collections])

  return (
     <div
      className='border-b border-slate-200 mb-5 bg-slate-100 p-8 border-dashed border-2'
     >
      <h2 className="text-2xl text-slate-500">
        <span className="text-lime-600 font-extrabold">Mongo DB</span> <span>(experimental)</span>
      </h2>
      <p className="text-sm text-slate-600 mt-0 italic">contact <a href="mailto:hello@dessertdata.com">hello@dessertdata.com</a> to enable</p>
      <form className='mt-8'>
          <div className=''>
            <div>
              <label htmlFor="mongo-connection-string" className='block mt-6'>1. Mongo Connection String</label>
              <input id="mongo-connection-string" 
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="password"
                placeholder="mongodb+srv://username:password@prod.mongodb.net/DessertData?retryWrites=true&w=majority&readPreference=primary&connectTimeoutMS=9000&serverSelectionTimeoutMS=7000&maxIdleTimeMS=1000"
                value={connectionString}
                onChange={(e) => setConnectionString(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="written-at-field" className='block mt-10'>2. Update Field</label>
              <p className='text-sm my-0 italic text-slate-500'>
                Identify a field on each collection that can be used to identify records since the last sync. 
                <span className='font-bold block'>Collections without an update field are limited to 1000 rows</span>
              </p>

              {/* <p className='mb-0'>Global</p>
              <p className='mt-0 mb-2 text-sm italic text-slate-400'>This global value be used as default for unconfigured   collections below</p> */}
              <input id="written-at-field" 
                className="shadow appearance-none border rounded mt-2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="writtenAtUtc"
                value={writtenAtField}
                onChange={(e) => setWrittenAtField(e.target.value)}
              />
            </div>
            { collections && Object.keys(collections).length! > 0 &&
            <div>
              <label className='block mt-10'>3. Collection Config</label>
              <p className='text-sm my-0 italic text-slate-500'>
                You can override the Update Field for each collection below.  You can also disable syncing for any 
                individual collection.
              </p>

              { Object.keys(collections).map((c, idx) => (
                <div key={idx} className=''>
                  <div className='inline-block'>
                    <label htmlFor={`collection-${idx}`} className='block mt-3 text-sm'>{c}</label>
                    <input id={`collection-${idx}`} 
                      className="text-md shadow appearance-none border rounded py-0 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="writtenAtUtc"
                      value={collections[c]?.lastUpdatedField} 
                      onChange={(e) => handleCollectionChange(e.target.value, c)}
                    />
                  </div>
                  <div className='inline-block text-center ml-4'>
                    <button 
                      type="button"
                      className={`
                        border-2  border-solid hover:drop-shadow-lg
                        ${collections[c]?.syncing === false ? 
                          'border-slate-400 text-slate-400 bg-blue-100' : 
                          'border-blue-700 bg-blue-700 text-slate-50'
                        }
                        font-bold text-sm 
                        px-2 rounded
                      `}
                      onClick={(e) => handleSyncChange(c)}
                    >
                      { collections[c]?.syncing === false ? 'DISABLED' : 'ENABLED'  }
                    </button>
                    {/* <input 
                      className='ml-3' 
                      type="checkbox" 
                      checked={collections[c]?.syncing === false}
                      onChange={(e) => handleSyncChange(e.target.checked, c)}
                    />
                    <label htmlFor={`do-sync-${idx}`} className='block ml-1 text-sm'>disable sync</label> */}
                  </div>
                </div>
              ))}
            </div>

            }
            <div className='my-4'>
              <button 
                type="button"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                onClick={() => handleSaveConfigData({connectionString, writtenAtField, collections})}
              >
                { saved ? ' ✔️ ' : 'Save'}
              </button>
            </div>
          </div>
      </form>
      <div className='block text-red-600'>{ error }</div>   
    </div>    
  )
}

export default MongoConnectedApp